"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _formUrlencoded = _interopRequireDefault(require("form-urlencoded"));

var ProductQuantityNumber = /*#__PURE__*/function () {
  function ProductQuantityNumber(component) {
    (0, _classCallCheck2["default"])(this, ProductQuantityNumber);
    this.dom = {
      $component: component,
      $form: component.querySelector('.js-product-quantity-total').form,
      $total: component.querySelector('.js-product-quantity-total'),
      $increment: component.querySelector('.js-product-quantity-increment'),
      $decrement: component.querySelector('.js-product-quantity-decrement')
    };
    this.state = {
      updating: false,
      shouldAjaxUpdate: component.dataset.ajaxSubmit !== undefined ? true : false,
      quantity: parseInt(component.querySelector('.js-product-quantity-total').value, 10)
    };
    this.incremenetClickHandler = this.increment.bind(this);
    this.decrementClickHandler = this.decrement.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(ProductQuantityNumber, [{
    key: "mount",
    value: function mount() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('ProductQuantityNumber : mount', this);

      if (dom.$increment) {
        dom.$increment.addEventListener('click', this.incremenetClickHandler);
      }

      if (dom.$decrement) {
        dom.$decrement.addEventListener('click', this.decrementClickHandler);
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('ProductQuantityNumber : unmount', this);

      if (dom.$increment) {
        dom.$increment.removeEventListener('click', this.incremenetClickHandler);
      }

      if (dom.$decrement) {
        dom.$decrement.removeEventListener('click', this.decrementClickHandler);
      }
    }
  }, {
    key: "increment",
    value: function increment() {
      var dom = this.dom,
          state = this.state;
      console.log('ProductQuantityNumber : increment', this);

      if (!state.updating) {
        state.quantity += 1;
        dom.$total.value = state.quantity;
        state.updating = true;
        this.update();
      }
    }
  }, {
    key: "decrement",
    value: function decrement() {
      var dom = this.dom,
          state = this.state;
      console.log('ProductQuantityNumber : decrement', this);

      if (state.quantity > 1) {
        if (!state.updating) {
          state.quantity -= 1;
          dom.$total.value = state.quantity;
          state.updating = true;
          this.update();
        }
      }
    }
  }, {
    key: "update",
    value: function update() {
      var dom = this.dom,
          state = this.state;
      console.log('ProductQuantityNumber : update', this);
      var $form = dom.$total.form;
      var event = new Event('submit');

      if ($form) {
        if (state.shouldAjaxUpdate) {
          this.ajaxSubmit();
        } else {
          $form.submit();
        }
      }
    }
  }, {
    key: "formToObject",
    value: function formToObject() {
      var dom = this.dom,
          state = this.state;
      console.log('ProductQuantityNumber : formToObject', this);
      var object = Array.from(dom.$form.elements).reduce(function (data, element) {
        data[element.name] = element.value;
        return data;
      }, {});
      return object;
    }
  }, {
    key: "ajaxSubmit",
    value: function ajaxSubmit(event) {
      var dom = this.dom,
          state = this.state;
      console.log('ProductQuantityNumber : ajaxSubmit', this, event);

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      var data = this.formToObject();
      (0, _axios["default"])({
        method: 'post',
        url: dom.$form.action,
        data: (0, _formUrlencoded["default"])(data)
      }).then(function (response) {
        var customEvent = new CustomEvent('updateMiniCart', {
          detail: response.data
        });
        document.dispatchEvent(customEvent);
      })["catch"](function (response) {
        console.log(response);
        window.location.reload();
      });
    }
  }]);
  return ProductQuantityNumber;
}();

exports["default"] = ProductQuantityNumber;